import { render } from "./insure-report-add.vue?vue&type=template&id=042638e8&scoped=true&ts=true"
import script from "./insure-report-add.vue?vue&type=script&lang=ts"
export * from "./insure-report-add.vue?vue&type=script&lang=ts"

import "./insure-report-add.vue?vue&type=style&index=0&id=042638e8&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042638e8"]])

export default __exports__